import Alpine from 'alpinejs';

/**
 * Single accordion panel (`snippets/accordion.liquid`): tracks open state and,
 * when opened, closes any sibling `.accordion__panel` within the same
 * `.shopify-section` so only one stays open at a time.
 *
 *   x-data="accordionPanel({ open: {{ open }} })"
 *
 * @param {object}  opts
 * @param {boolean} opts.open  Initial open state (default false).
 */
export default function accordionPanel({ open = false } = {}) {
  return {
    open,
    init() {
      this.$watch('open', (openValue) => {
        if (!openValue) return;
        this.$el
          .closest('.shopify-section')
          ?.querySelectorAll('.accordion__panel')
          .forEach((panel) => {
            if (this.$el === panel) return;
            const data = Alpine.$data(panel);
            if (!data?.open) return;
            data.open = false;
          });
      });
    },
  };
}
